(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["product-cta"] && !Shopify.designMode) return;
  try {
    // The block renders in its own section, so the bubbling `variant:update` event raised
  // by the variant picker in the main product section never reaches its product form.
  // Listen on the document and mirror the change onto every Product CTA for that product.
  (() => {
    const SELECTOR = '.product-cta__form-host';

    document.addEventListener('variant:update', (event) => {
      const detail = event.detail;
      if (!detail) return;

      const resource = detail.resource;
      const productId = detail.data && detail.data.productId;
      const newProductId = detail.data && detail.data.newProduct && detail.data.newProduct.id;

      document.querySelectorAll(SELECTOR).forEach((host) => {
        const matchesProduct = productId != null && String(host.dataset.productId) === String(productId);
        if (!matchesProduct) return;

        // Combined listings can swap in a different product entirely.
        if (newProductId) host.dataset.productId = String(newProductId);

        const input = host.querySelector('[ref="variantId"]');
        if (input && resource && resource.id) input.value = resource.id;

        const button = host.querySelector('[ref="addToCartButton"]');
        if (!button) return;

        if (resource && resource.available) {
          button.removeAttribute('disabled');
        } else {
          button.setAttribute('disabled', 'true');
        }
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
